import { financeProjectMessagesEn, financeProjectMessagesTh } from './finance-project';
import { miscUiMessagesEn, miscUiMessagesTh } from './misc-ui';

export const featureMessagesTh: Record<string, string> = {
  'category.general': 'ทั่วไป',

  'due.noDue': 'ไม่มีกำหนด',
  'due.overdue': 'เลยกำหนดส่ง',
  'due.dueToday': 'ครบกำหนดวันนี้',
  'due.dueTomorrow': 'ครบกำหนดพรุ่งนี้',
  'due.soon48h': 'ใกล้ครบกำหนด (48h)',

  'errors.unauthorized': 'ต้องเข้าสู่ระบบก่อนใช้งาน',
  'errors.categoryNameRequired': 'กรุณาระบุชื่อหมวดหมู่',
  'errors.taskTitleRequired': 'กรุณาระบุชื่องาน',
  'errors.eventTitleRequired': 'กรุณาระบุชื่อกิจกรรม',
  'errors.eventNotFound': 'ไม่พบกิจกรรม',
  'errors.invalidEventDate': 'วันที่กิจกรรมไม่ถูกต้อง',
  'errors.endBeforeStart': 'วันสิ้นสุดต้องไม่มาก่อนวันเริ่มต้น',
  'errors.invalidDateFormat': 'รูปแบบวันที่ไม่ถูกต้อง',

  'myTasks.title': 'งานของฉัน (My Tasks)',
  'myTasks.subtitle': 'งานส่วนตัว + งานจากโปรเจกต์ที่ได้รับมอบหมาย — เห็นเฉพาะของคุณ',
  'myTasks.categories': 'หมวดหมู่',
  'myTasks.addTask': 'เพิ่มงาน',
  'myTasks.all': 'ทั้งหมด',
  'myTasks.pending': 'ค้างอยู่',
  'myTasks.overdue': 'เกินกำหนด',
  'myTasks.done': 'เสร็จแล้ว',
  'myTasks.modeCategory': 'หมวดหมู่',
  'myTasks.modeTimeline': 'ไทมไลน์',
  'myTasks.assignedFromProject': 'งานที่ได้รับมอบหมายจากโปรเจกต์',
  'myTasks.openProject': 'เปิดโปรเจกต์',
  'myTasks.progressChecks': 'ความคืบหน้า ({count} เช็ค)',
  'myTasks.project': 'โปรเจกต์',
  'myTasks.viewInProject': 'ดูในโปรเจกต์',
  'myTasks.personalTasks': 'งานส่วนตัว',
  'myTasks.emptyNoTasks': 'ยังไม่มีงานของคุณ — กด “เพิ่มงาน” เพื่อสร้างงานชิ้นแรก',
  'myTasks.emptyNoTasksInCategory': 'ไม่มีงานในหมวด «{category}»',
  'myTasks.emptyNoPending': 'ไม่มีงานที่ค้างอยู่ 🎉',
  'myTasks.emptyNoDone': 'ยังไม่มีงานที่เสร็จแล้ว',
  'myTasks.markIncomplete': 'ทำเครื่องหมายว่ายังไม่เสร็จ',
  'myTasks.markComplete': 'ทำเครื่องหมายว่าเสร็จ',
  'myTasks.stash': 'เก็บชั่วคราว',
  'myTasks.edit': 'แก้ไข',
  'myTasks.delete': 'ลบ',
  'myTasks.tempStorage': 'ช่องจัดเก็บชั่วคราว',
  'myTasks.restore': 'ดึงกลับ',
  'myTasks.restoreTitle': 'ดึงงานกลับ',
  'myTasks.editTask': 'แก้ไขงาน',
  'myTasks.newTask': 'เพิ่มงานใหม่',
  'myTasks.taskTitle': 'หัวข้องาน',
  'myTasks.taskTitlePlaceholder': 'เช่น เขียนสรุปแผนงานประจำสัปดาห์',
  'myTasks.description': 'รายละเอียด (ไม่จำเป็น)',
  'myTasks.descriptionPlaceholder': 'รายละเอียดเพิ่มเติม...',
  'myTasks.noCategoriesYet': 'ยังไม่มีหมวดหมู่ —',
  'myTasks.addCategoryLink': 'เพิ่มหมวดหมู่',
  'myTasks.colorByCategory': 'สีงานตามหมวดหมู่ — แก้ไขสีได้ที่ปุ่ม 「หมวดหมู่」',
  'myTasks.dueDate': 'กำหนดส่ง (ไทมไลน์)',
  'myTasks.saveEdit': 'บันทึกการแก้ไข',
  'myTasks.manageCategoryColors': 'จัดการสีหมวดหมู่',
  'myTasks.categoryColorsDesc': 'กำหนดสีหมวดหมู่ส่วนตัว — แสดงในงานของฉันและปฏิทิน (เห็นเฉพาะคุณ)',
  'myTasks.noCategories': 'ยังไม่มีหมวดหมู่',
  'myTasks.addNewCategory': 'เพิ่มหมวดหมู่ใหม่',
  'myTasks.categoryNamePlaceholder': 'ชื่อหมวดหมู่ เช่น ประชุม, ดิสคอร์ด',
  'myTasks.add': 'เพิ่ม',
  'myTasks.deleteCategoryColor': 'ลบสีหมวดหมู่',
  'myTasks.toast.categoryColorSaveFailed': 'บันทึกสีหมวดหมู่ไม่สำเร็จ',
  'myTasks.toast.categoryAdded': 'เพิ่มหมวดหมู่แล้ว',
  'myTasks.toast.categoryAddFailed': 'เพิ่มหมวดหมู่ไม่สำเร็จ',
  'myTasks.confirm.deleteCategory': 'ลบสีหมวดหมู่ "{name}"? (งานในหมวดนี้จะยังอยู่)',
  'myTasks.toast.categoryDeleted': 'ลบหมวดหมู่แล้ว',
  'myTasks.toast.taskUpdated': 'แก้ไขงานแล้ว',
  'myTasks.toast.taskCreated': 'เพิ่มงานใหม่แล้ว',
  'myTasks.toast.taskCompleted': 'ทำงานเสร็จแล้ว เยี่ยม!',
  'myTasks.confirm.deleteTask': 'ต้องการลบงาน "{title}" ใช่หรือไม่?',
  'myTasks.toast.taskDeleted': 'ลบงานเรียบร้อย',
  'myTasks.toast.stashed': 'เก็บงานเข้าช่องชั่วคราวแล้ว',
  'myTasks.toast.restored': 'ดึงงานกลับมาแล้ว',

  'myTasks.timeline.none': 'ไม่มีกำหนด',
  'myTasks.timeline.overdue': 'เกินกำหนด',
  'myTasks.timeline.today': 'วันนี้',
  'myTasks.timeline.tomorrow': 'พรุ่งนี้',
  'myTasks.timeline.week': 'ภายใน 7 วัน',
  'myTasks.timeline.later': 'ภายหลัง',

  'myTasks.status.planning': 'วางแผน',
  'myTasks.status.active': 'กำลังทำ',
  'myTasks.status.todo': 'รอทำ',
  'myTasks.status.in_progress': 'กำลังดำเนินการ',
  'myTasks.status.testing': 'ทดสอบ',

  'calendar.title': 'ปฏิทินระบบ & กิจกรรม',
  'calendar.subtitle': 'งานโปรเจกต์เห็นร่วมกัน · งานส่วนตัวเห็นเฉพาะคุณ',
  'calendar.viewDay': 'รายวัน',
  'calendar.viewWeek': 'รายสัปดาห์',
  'calendar.viewMonth': 'รายเดือน',
  'calendar.today': 'วันนี้',
  'calendar.todayParen': '(วันนี้)',
  'calendar.createEvent': 'สร้างกิจกรรมใหม่',
  'calendar.colorDay': 'ใส่สีให้วันนี้',
  'calendar.personalTask': 'งานส่วนตัว',
  'calendar.deadline': 'กำหนดส่งงาน',
  'calendar.itemsCount': '{count} รายการ',
  'calendar.more': '+{count} more',
  'calendar.noEventsToday': 'ไม่มีกิจกรรมหรือกำหนดส่งงานในวันนี้',
  'calendar.addEventToday': 'เพิ่มกิจกรรมในวันนี้',
  'calendar.addEvent': 'เพิ่มกิจกรรมใหม่',
  'calendar.editEvent': 'แก้ไขกิจกรรม',
  'calendar.eventTitle': 'หัวข้อกิจกรรม',
  'calendar.eventTitlePlaceholder': 'เช่น ประชุมวางแผนเปิดซีซั่น',
  'calendar.startDate': 'เริ่มวันที่',
  'calendar.endDate': 'สิ้นสุดวันที่',
  'calendar.eventColor': 'สีกิจกรรม',
  'calendar.eventColorHint': 'เลือกจากชุดสีหรือกำหนดสีเองได้',
  'calendar.createEventBtn': 'สร้างกิจกรรม',
  'calendar.saveEventBtn': 'บันทึกการแก้ไข',
  'calendar.starts': 'เริ่ม:',
  'calendar.ends': 'สิ้นสุด:',
  'calendar.type': 'ประเภท:',
  'calendar.typeMeeting': 'ประชุม / ทั่วไป',
  'calendar.typeDev': 'งานพัฒนาสคริปต์',
  'calendar.typeUrgent': 'ด่วน / ปิดปรับปรุง',
  'calendar.typeServer': 'กิจกรรมเซิร์ฟเวอร์',
  'calendar.deleteEvent': 'ลบกิจกรรม',
  'calendar.ok': 'ตกลง',
  'calendar.colorDayTitle': 'ใส่สีให้วัน',
  'calendar.removeColor': 'ลบสี',
  'calendar.done': 'เสร็จสิ้น',
  'calendar.personalTaskWithCategory': 'งานส่วนตัว{suffix}',
  'calendar.deadlineWithProject': 'กำหนดส่ง{suffix}',
  'calendar.toast.dayColorSet': 'ตั้งสีประจำวันแล้ว',
  'calendar.toast.dayColorCleared': 'ลบสีประจำวันแล้ว',
  'calendar.toast.eventCreated': 'เพิ่มนัดหมายสำเร็จแล้ว',
  'calendar.toast.eventCreateFailed': 'เพิ่มกิจกรรมไม่สำเร็จ',
  'calendar.toast.eventUpdated': 'บันทึกการแก้ไขแล้ว',
  'calendar.toast.eventUpdateFailed': 'บันทึกการแก้ไขไม่สำเร็จ',
  'calendar.confirm.deleteEvent': 'ต้องการลบกิจกรรมนัดหมายนี้ใช่หรือไม่?',
  'calendar.toast.eventDeleted': 'ลบกิจกรรมสำเร็จ',

  'calendar.dayColor.blue': 'ฟ้า',
  'calendar.dayColor.green': 'เขียว',
  'calendar.dayColor.red': 'แดง',
  'calendar.dayColor.yellow': 'เหลือง',
  'calendar.dayColor.purple': 'ม่วง',
  'calendar.dayColor.pink': 'ชมพู',
  'calendar.dayColor.cyan': 'ฟ้าคราม',
  'calendar.dayColor.gray': 'เทา',

  'server.kpiAdminStaff': 'ทีมงานแอดมิน',
  'server.kpiStaffCount': '{active} Active / {total}',
  'server.kpiTotalRevenue': 'รายรับรวมเซิร์ฟเวอร์',
  'server.tabRoster': 'ทำเนียบทีมงาน',
  'server.tabProfitShare': 'ส่วนแบ่งเปอร์เซ็นรายได้',
  'server.rosterTitle': 'รายชื่อและบทบาททีมงานเซิร์ฟเวอร์ (Staff Roster)',
  'server.addStaff': 'เพิ่มทีมงาน',
  'server.colName': 'ชื่อเล่น (Discord / Name)',
  'server.colDepartment': 'ฝ่ายงาน (Department)',
  'server.colRole': 'ตำแหน่งหน้าที่ (Role)',
  'server.colJoinDate': 'วันที่ร่วมทีม',
  'server.colStatus': 'สถานะการทำงาน',
  'server.verified': 'Verified',
  'server.statusActive': 'ปฏิบัติงาน',
  'server.statusInactive': 'พ้นตำแหน่ง',
  'server.managedViaAccount': 'จัดการผ่านระบบบัญชี',
  'server.emptyRoster': 'ไม่พบทำเนียบรายชื่อทีมงาน',
  'server.profitShareTitle': 'ส่วนแบ่งเปอร์เซ็นรายได้ (Revenue Share Configuration)',
  'server.profitShareDesc': 'กำหนดรายได้ปันผลของบุคลากรตาม % ของผลตอบแทนรวมเซิร์ฟเวอร์',
  'server.serverShareTooltip': 'ส่วนของ Server: {pct}%',
  'server.unallocated': 'ไม่ได้จัดสรร: {pct}%',
  'server.colAvatar': 'รูปโปรไฟล์',
  'server.colDiscordName': 'ชื่อทีมงาน Discord',
  'server.colDiscordRole': 'ระดับสิทธิ์ระบบ (Discord Role)',
  'server.colSharePct': 'ส่วนแบ่งเปอร์เซ็นต์ (%)',
  'server.colNetPay': 'คงเหลือจ่ายจริง (THB)',
  'server.serverFund': 'กองทุนเซิร์ฟเวอร์ (Server Fund)',
  'server.system': 'SYSTEM',
  'server.save': 'บันทึก',
  'server.editServerShare': 'แก้ไขส่วนแบ่งเซิร์ฟเวอร์',
  'server.editAdminShare': 'แก้ไขสัดส่วนปันผล',
  'server.emptyProfitShare': 'ไม่พบบุคลากรที่มีสิทธิ์การปันผลในระบบ',
  'server.editStaff': 'แก้ไขข้อมูลทีมงาน',
  'server.addServerStaff': 'เพิ่มทีมงานเซิร์ฟเวอร์',
  'server.formName': 'ชื่อ (Discord / Name)',
  'server.formNamePlaceholder': 'เช่น Somchai#1234',
  'server.formDepartment': 'ฝ่าย (Department)',
  'server.formDepartmentPlaceholder': 'เช่น Dev, Admin, Support',
  'server.formRole': 'ตำแหน่ง (Role)',
  'server.formRolePlaceholder': 'เช่น Senior Scripting',
  'server.formJoinDate': 'วันที่ร่วมทีม',
  'server.formStatus': 'สถานะ',
  'server.formStatusActive': 'ปฏิบัติงาน (Active)',
  'server.formStatusInactive': 'พ้นตำแหน่ง (Inactive)',
  'server.saveEdit': 'บันทึกการแก้ไข',
  'server.deptManagement': 'Management',
  'server.deptDevelopment': 'Development',
  'server.deptAdmin': 'Admin',
  'server.toast.staffUpdated': 'แก้ไขข้อมูลทีมงานเรียบร้อยแล้ว',
  'server.toast.staffCreated': 'เพิ่มทีมงานใหม่เรียบร้อยแล้ว',
  'server.confirmDeleteStaff': 'ต้องการลบรายชื่อทีมงานนี้ใช่หรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้',
  'server.toast.staffDeleted': 'ลบรายชื่อทีมงานสำเร็จ',
  'server.toast.shareExceeded': 'ยอดรวมส่วนแบ่งเกิน 100% (สามารถกำหนดได้สูงสุด {max}%)',
  'server.toast.adminShareUpdated': 'อัปเดตสัดส่วนปันผลแอดมินสำเร็จ',
  'server.error.saveShare': 'เกิดข้อผิดพลาดในการบันทึกส่วนแบ่ง',
  'server.toast.serverShareExceeded': 'ยอดรวมส่วนแบ่งเกิน 100% (เซิร์ฟเวอร์ตั้งได้สูงสุด {max}%)',
  'server.toast.serverShareUpdated': 'อัปเดตสัดส่วนปันผลเซิร์ฟเวอร์สำเร็จ',
  'server.error.saveServerShare': 'เกิดข้อผิดพลาดในการบันทึกส่วนแบ่งเซิร์ฟเวอร์',
  'server.toast.serverMaxShare': 'เซิร์ฟเวอร์ตั้งได้สูงสุด {max}%',
  'server.toast.totalShareExceeded': 'ส่วนแบ่งรวมห้ามเกิน 100% (เหลือ {max}%)',

  'dashboard.widget.welcomeBanner': 'แบนเนอร์ต้อนรับ',
  'dashboard.widget.monthlyFinance': 'สรุปการเงินเดือนนี้',
  'dashboard.widget.kpiBalance': 'สถิติการเงินสุทธิ',
  'dashboard.widget.myTasks': 'งานส่วนตัวที่ค้างอยู่',
  'dashboard.widget.quickEvents': 'กิจกรรมที่จะถึง',
  'dashboard.widget.financeChart': 'กราฟวิเคราะห์การเงิน',
  'dashboard.widget.quickTasks': 'งานด่วนที่สำคัญ',
  'dashboard.widget.projectPending': 'งานโปรเจกต์ที่ค้างอยู่',
  'dashboard.week': 'สัปดาห์ ',
  'dashboard.welcomeBack': 'ยินดีต้อนรับกลับมา,',
  'dashboard.roleLine': 'บทบาทของคุณคือ: {role} | ดำเนินการเชื่อมโยงระบบสำเร็จ',
  'dashboard.income': 'รายรับ',
  'dashboard.expense': 'รายจ่าย',
  'dashboard.netProfit': 'กำไรสุทธิ',
  'dashboard.netBalance': 'กำไรสุทธิ (Balance)',
  'dashboard.financeChartTitle': 'กราฟวิเคราะห์รายรับรายจ่าย',
  'dashboard.chartIncome': 'รายรับ (THB)',
  'dashboard.chartExpense': 'รายจ่าย (THB)',
  'dashboard.urgentTasks': 'งานเร่งด่วนและสำคัญ',
  'dashboard.noUrgentTasks': 'ไม่มีงานด่วนคงค้าง',
  'dashboard.noUrgentTasksDesc': 'ยินดีด้วย! บอร์ดไม่มีงานเร่งด่วนที่ค้างในขณะนี้',
  'dashboard.upcomingEvents': 'กิจกรรมที่จะถึง',
  'dashboard.noUpcomingEvents': 'ไม่มีกิจกรรมเร็วๆ นี้',
  'dashboard.noUpcomingEventsDesc': 'ช่วงนี้ยังไม่มีแผนงานประชุมหรือซ่อมบำรุงเซิร์ฟเวอร์',
  'dashboard.eventCountdownDays': 'อีก {count} วัน',
  'dashboard.myPendingTasks': 'งานส่วนตัวที่ค้างอยู่',
  'dashboard.noMyTasks': 'ไม่มีงานส่วนตัวค้างอยู่ 🎉',
  'dashboard.noMyTasksDesc': 'งานส่วนตัวของคุณเคลียร์หมดแล้ว',
  'dashboard.projectPending': 'งานโปรเจกต์ที่ค้างอยู่',
  'dashboard.noProject': 'ไม่มีโปรเจกต์',
  'dashboard.noProjectTasks': 'ไม่มีงานโปรเจกต์ค้างอยู่',
  'dashboard.noProjectTasksDesc': 'ทุกงานในบอร์ดเสร็จเรียบร้อยแล้ว',
  'dashboard.title': 'แผงควบคุมหลัก',
  'dashboard.doneCustomizing': 'เสร็จสิ้นการปรับแต่ง',
  'dashboard.customizeWidgets': 'ปรับแต่งวิดเจ็ต',
  'dashboard.refreshTitle': 'รีเฟรชข้อมูลแดชบอร์ด',
  'dashboard.refresh': 'รีเฟรช',
  'dashboard.customizerTitle': '⚙️ จัดการวิดเจ็ตแดชบอร์ด (Customizer Panel)',
  'dashboard.ok': 'ตกลง',
  'dashboard.customizerHint': 'เปิด/ปิดวิดเจ็ตด้วยการติ๊กกล่อง และ ลากป้ายชื่อ (⋮) บนวิดเจ็ตเพื่อจัดเรียงลำดับ',
  'dashboard.resetAll': 'รีเซ็ตทั้งหมด',
  'dashboard.toast.layoutReset': 'รีเซ็ตเลย์เอาต์หน้าต่างเริ่มต้นสำเร็จ',
  'dashboard.dragToReorder': 'ลากเพื่อจัดเรียง',

  'notifications.projectDueSoon': 'งานโปรเจกต์ใกล้ครบกำหนด',
  'notifications.personalDueSoon': 'งานของฉันใกล้ครบกำหนด',
  'notifications.changelogUpdate': 'อัปเดต v{version}',
  'notifications.financeAlertTitle': 'รายจ่ายเดือนนี้ใกล้/เกินงบ',
  'notifications.financeAlertMessage': 'รวม {total} (เกณฑ์ {threshold})',

  'changelog.title': 'อัปเดตและแพตช์โน้ต',
  'changelog.newPatch': 'เพิ่มแพตช์ใหม่',
  'changelog.editPatch': 'แก้ไข',
  'changelog.emptyTitle': 'ยังไม่มีประวัติอัปเดต',
  'changelog.emptyDesc': 'เมื่อมีการอัปเดตระบบ จะแสดงรายการที่นี่',
  'changelog.modalEdit': 'แก้ไขแพตช์โน้ต',
  'changelog.modalCreate': 'เพิ่มแพตช์โน้ตใหม่',
  'changelog.version': 'เวอร์ชัน',
  'changelog.mainTitle': 'หัวข้อ',
  'changelog.details': 'รายละเอียดการอัปเดต',
  'changelog.publish': 'เผยแพร่',
  'changelog.updated': 'อัปเดตแพตช์โน้ตแล้ว',
  'changelog.saved': 'บันทึกแพตช์โน้ตแล้ว',
  'changelog.confirmDelete': 'ต้องการลบแพตช์โน้ตนี้ใช่หรือไม่?',
  'changelog.deleted': 'ลบแพตช์โน้ตแล้ว',
  'errors.changelogRequired': 'กรุณาระบุเวอร์ชันและหัวข้ออัปเดต',

  ...financeProjectMessagesTh,
  ...miscUiMessagesTh,
};

export const featureMessagesEn: Record<string, string> = {
  'category.general': 'General',

  'due.noDue': 'No due date',
  'due.overdue': 'Overdue',
  'due.dueToday': 'Due today',
  'due.dueTomorrow': 'Due tomorrow',
  'due.soon48h': 'Due soon (48h)',

  'errors.unauthorized': 'Please sign in to continue',
  'errors.categoryNameRequired': 'Category name is required',
  'errors.taskTitleRequired': 'Task title is required',
  'errors.eventTitleRequired': 'Event title is required',
  'errors.eventNotFound': 'Event not found',
  'errors.invalidEventDate': 'Invalid event date',
  'errors.endBeforeStart': 'End date cannot be before start date',
  'errors.invalidDateFormat': 'Invalid date format',

  'myTasks.title': 'My Tasks',
  'myTasks.subtitle': 'Personal tasks and project assignments — visible only to you',
  'myTasks.categories': 'Categories',
  'myTasks.addTask': 'Add task',
  'myTasks.all': 'All',
  'myTasks.pending': 'Pending',
  'myTasks.overdue': 'Overdue',
  'myTasks.done': 'Done',
  'myTasks.modeCategory': 'Category',
  'myTasks.modeTimeline': 'Timeline',
  'myTasks.assignedFromProject': 'Assigned from projects',
  'myTasks.openProject': 'Open projects',
  'myTasks.progressChecks': 'Progress ({count} checks)',
  'myTasks.project': 'Project',
  'myTasks.viewInProject': 'View in project',
  'myTasks.personalTasks': 'Personal tasks',
  'myTasks.emptyNoTasks': 'No tasks yet — click “Add task” to create your first one',
  'myTasks.emptyNoTasksInCategory': 'No tasks in category «{category}»',
  'myTasks.emptyNoPending': 'No pending tasks 🎉',
  'myTasks.emptyNoDone': 'No completed tasks yet',
  'myTasks.markIncomplete': 'Mark as incomplete',
  'myTasks.markComplete': 'Mark as complete',
  'myTasks.stash': 'Stash temporarily',
  'myTasks.edit': 'Edit',
  'myTasks.delete': 'Delete',
  'myTasks.tempStorage': 'Temporary stash',
  'myTasks.restore': 'Restore',
  'myTasks.restoreTitle': 'Restore task',
  'myTasks.editTask': 'Edit task',
  'myTasks.newTask': 'New task',
  'myTasks.taskTitle': 'Task title',
  'myTasks.taskTitlePlaceholder': 'e.g. Write weekly plan summary',
  'myTasks.description': 'Description (optional)',
  'myTasks.descriptionPlaceholder': 'Additional details...',
  'myTasks.noCategoriesYet': 'No categories yet —',
  'myTasks.addCategoryLink': 'Add category',
  'myTasks.colorByCategory': 'Task color follows category — edit colors via the Categories button',
  'myTasks.dueDate': 'Due date (timeline)',
  'myTasks.saveEdit': 'Save changes',
  'myTasks.manageCategoryColors': 'Manage category colors',
  'myTasks.categoryColorsDesc': 'Set personal category colors — shown in My Tasks and Calendar (only you)',
  'myTasks.noCategories': 'No categories yet',
  'myTasks.addNewCategory': 'Add new category',
  'myTasks.categoryNamePlaceholder': 'Category name, e.g. Meeting, Discord',
  'myTasks.add': 'Add',
  'myTasks.deleteCategoryColor': 'Remove category color',
  'myTasks.toast.categoryColorSaveFailed': 'Failed to save category color',
  'myTasks.toast.categoryAdded': 'Category added',
  'myTasks.toast.categoryAddFailed': 'Failed to add category',
  'myTasks.confirm.deleteCategory': 'Remove color for category "{name}"? (Tasks in this category remain)',
  'myTasks.toast.categoryDeleted': 'Category removed',
  'myTasks.toast.taskUpdated': 'Task updated',
  'myTasks.toast.taskCreated': 'Task created',
  'myTasks.toast.taskCompleted': 'Task completed — nice work!',
  'myTasks.confirm.deleteTask': 'Delete task "{title}"?',
  'myTasks.toast.taskDeleted': 'Task deleted',
  'myTasks.toast.stashed': 'Task moved to stash',
  'myTasks.toast.restored': 'Task restored',

  'myTasks.timeline.none': 'No due date',
  'myTasks.timeline.overdue': 'Overdue',
  'myTasks.timeline.today': 'Today',
  'myTasks.timeline.tomorrow': 'Tomorrow',
  'myTasks.timeline.week': 'Within 7 days',
  'myTasks.timeline.later': 'Later',

  'myTasks.status.planning': 'Planning',
  'myTasks.status.active': 'Active',
  'myTasks.status.todo': 'To do',
  'myTasks.status.in_progress': 'In progress',
  'myTasks.status.testing': 'Testing',

  'calendar.title': 'Calendar & events',
  'calendar.subtitle': 'Project tasks are shared · personal tasks are private',
  'calendar.viewDay': 'Day',
  'calendar.viewWeek': 'Week',
  'calendar.viewMonth': 'Month',
  'calendar.today': 'Today',
  'calendar.todayParen': '(today)',
  'calendar.createEvent': 'New event',
  'calendar.colorDay': 'Color this day',
  'calendar.personalTask': 'Personal task',
  'calendar.deadline': 'Deadline',
  'calendar.itemsCount': '{count} items',
  'calendar.more': '+{count} more',
  'calendar.noEventsToday': 'No events or deadlines today',
  'calendar.addEventToday': 'Add event for today',
  'calendar.addEvent': 'New event',
  'calendar.editEvent': 'Edit event',
  'calendar.eventTitle': 'Event title',
  'calendar.eventTitlePlaceholder': 'e.g. Season launch planning meeting',
  'calendar.startDate': 'Start date',
  'calendar.endDate': 'End date',
  'calendar.eventColor': 'Event color',
  'calendar.eventColorHint': 'Pick from the palette or choose a custom color',
  'calendar.createEventBtn': 'Create event',
  'calendar.saveEventBtn': 'Save changes',
  'calendar.starts': 'Starts:',
  'calendar.ends': 'Ends:',
  'calendar.type': 'Type:',
  'calendar.typeMeeting': 'Meeting / general',
  'calendar.typeDev': 'Script development',
  'calendar.typeUrgent': 'Urgent / maintenance',
  'calendar.typeServer': 'Server event',
  'calendar.deleteEvent': 'Delete event',
  'calendar.ok': 'OK',
  'calendar.colorDayTitle': 'Color day',
  'calendar.removeColor': 'Remove color',
  'calendar.done': 'Done',
  'calendar.personalTaskWithCategory': 'Personal task{suffix}',
  'calendar.deadlineWithProject': 'Deadline{suffix}',
  'calendar.toast.dayColorSet': 'Day color saved',
  'calendar.toast.dayColorCleared': 'Day color removed',
  'calendar.toast.eventCreated': 'Event created',
  'calendar.toast.eventCreateFailed': 'Failed to create event',
  'calendar.toast.eventUpdated': 'Event updated',
  'calendar.toast.eventUpdateFailed': 'Failed to update event',
  'calendar.confirm.deleteEvent': 'Delete this event?',
  'calendar.toast.eventDeleted': 'Event deleted',

  'calendar.dayColor.blue': 'Blue',
  'calendar.dayColor.green': 'Green',
  'calendar.dayColor.red': 'Red',
  'calendar.dayColor.yellow': 'Yellow',
  'calendar.dayColor.purple': 'Purple',
  'calendar.dayColor.pink': 'Pink',
  'calendar.dayColor.cyan': 'Cyan',
  'calendar.dayColor.gray': 'Gray',

  'server.kpiAdminStaff': 'Admin staff',
  'server.kpiStaffCount': '{active} Active / {total}',
  'server.kpiTotalRevenue': 'Total server revenue',
  'server.tabRoster': 'Staff roster',
  'server.tabProfitShare': 'Revenue share %',
  'server.rosterTitle': 'Staff roster & roles',
  'server.addStaff': 'Add staff',
  'server.colName': 'Nickname (Discord / Name)',
  'server.colDepartment': 'Department',
  'server.colRole': 'Role',
  'server.colJoinDate': 'Join date',
  'server.colStatus': 'Status',
  'server.verified': 'Verified',
  'server.statusActive': 'Active',
  'server.statusInactive': 'Inactive',
  'server.managedViaAccount': 'Managed via account system',
  'server.emptyRoster': 'No staff roster entries found',
  'server.profitShareTitle': 'Revenue share configuration',
  'server.profitShareDesc': 'Set staff profit share as a % of total server revenue',
  'server.serverShareTooltip': 'Server share: {pct}%',
  'server.unallocated': 'Unallocated: {pct}%',
  'server.colAvatar': 'Avatar',
  'server.colDiscordName': 'Discord name',
  'server.colDiscordRole': 'System role (Discord Role)',
  'server.colSharePct': 'Share (%)',
  'server.colNetPay': 'Estimated payout (THB)',
  'server.serverFund': 'Server fund',
  'server.system': 'SYSTEM',
  'server.save': 'Save',
  'server.editServerShare': 'Edit server share',
  'server.editAdminShare': 'Edit profit share',
  'server.emptyProfitShare': 'No staff with profit share rights',
  'server.editStaff': 'Edit staff',
  'server.addServerStaff': 'Add server staff',
  'server.formName': 'Name (Discord / Name)',
  'server.formNamePlaceholder': 'e.g. Somchai#1234',
  'server.formDepartment': 'Department',
  'server.formDepartmentPlaceholder': 'e.g. Dev, Admin, Support',
  'server.formRole': 'Role',
  'server.formRolePlaceholder': 'e.g. Senior Scripting',
  'server.formJoinDate': 'Join date',
  'server.formStatus': 'Status',
  'server.formStatusActive': 'Active',
  'server.formStatusInactive': 'Inactive',
  'server.saveEdit': 'Save changes',
  'server.deptManagement': 'Management',
  'server.deptDevelopment': 'Development',
  'server.deptAdmin': 'Admin',
  'server.toast.staffUpdated': 'Staff member updated',
  'server.toast.staffCreated': 'Staff member added',
  'server.confirmDeleteStaff': 'Delete this staff member? This cannot be undone.',
  'server.toast.staffDeleted': 'Staff member deleted',
  'server.toast.shareExceeded': 'Total share exceeds 100% (max {max}%)',
  'server.toast.adminShareUpdated': 'Admin profit share updated',
  'server.error.saveShare': 'Failed to save share',
  'server.toast.serverShareExceeded': 'Total share exceeds 100% (server max {max}%)',
  'server.toast.serverShareUpdated': 'Server profit share updated',
  'server.error.saveServerShare': 'Failed to save server share',
  'server.toast.serverMaxShare': 'Server share cannot exceed {max}%',
  'server.toast.totalShareExceeded': 'Total share cannot exceed 100% ({max}% remaining)',

  'dashboard.widget.welcomeBanner': 'Welcome banner',
  'dashboard.widget.monthlyFinance': 'This month finances',
  'dashboard.widget.kpiBalance': 'Net balance stats',
  'dashboard.widget.myTasks': 'Pending personal tasks',
  'dashboard.widget.quickEvents': 'Upcoming events',
  'dashboard.widget.financeChart': 'Finance chart',
  'dashboard.widget.quickTasks': 'Urgent tasks',
  'dashboard.widget.projectPending': 'Pending project tasks',
  'dashboard.week': 'Week ',
  'dashboard.welcomeBack': 'Welcome back,',
  'dashboard.roleLine': 'Your role: {role} | System sync complete',
  'dashboard.income': 'Income',
  'dashboard.expense': 'Expense',
  'dashboard.netProfit': 'Net profit',
  'dashboard.netBalance': 'Net balance',
  'dashboard.financeChartTitle': 'Income vs expense chart',
  'dashboard.chartIncome': 'Income (THB)',
  'dashboard.chartExpense': 'Expense (THB)',
  'dashboard.urgentTasks': 'Urgent & important tasks',
  'dashboard.noUrgentTasks': 'No urgent tasks pending',
  'dashboard.noUrgentTasksDesc': 'Great! No urgent tasks on the board right now.',
  'dashboard.upcomingEvents': 'Upcoming events',
  'dashboard.noUpcomingEvents': 'No events coming up',
  'dashboard.noUpcomingEventsDesc': 'No meetings or server maintenance scheduled soon.',
  'dashboard.eventCountdownDays': 'In {count} days',
  'dashboard.myPendingTasks': 'Pending personal tasks',
  'dashboard.noMyTasks': 'No pending personal tasks 🎉',
  'dashboard.noMyTasksDesc': 'All your personal tasks are cleared.',
  'dashboard.projectPending': 'Pending project tasks',
  'dashboard.noProject': 'No project',
  'dashboard.noProjectTasks': 'No pending project tasks',
  'dashboard.noProjectTasksDesc': 'All board tasks are complete.',
  'dashboard.title': 'Main dashboard',
  'dashboard.doneCustomizing': 'Done customizing',
  'dashboard.customizeWidgets': 'Customize widgets',
  'dashboard.refreshTitle': 'Refresh dashboard data',
  'dashboard.refresh': 'Refresh',
  'dashboard.customizerTitle': '⚙️ Dashboard widget customizer',
  'dashboard.ok': 'OK',
  'dashboard.customizerHint': 'Toggle widgets with checkboxes, and drag the label (⋮) on a widget to reorder.',
  'dashboard.resetAll': 'Reset all',
  'dashboard.toast.layoutReset': 'Dashboard layout reset to default',
  'dashboard.dragToReorder': 'Drag to reorder',

  'notifications.projectDueSoon': 'Project task due soon',
  'notifications.personalDueSoon': 'Personal task due soon',
  'notifications.changelogUpdate': 'Update v{version}',
  'notifications.financeAlertTitle': 'Monthly spending near/over budget',
  'notifications.financeAlertMessage': 'Total {total} (threshold {threshold})',

  'changelog.title': 'Patch notes',
  'changelog.newPatch': 'New patch',
  'changelog.editPatch': 'Edit',
  'changelog.emptyTitle': 'No updates yet',
  'changelog.emptyDesc': 'System updates will appear here',
  'changelog.modalEdit': 'Edit patch',
  'changelog.modalCreate': 'New patch',
  'changelog.version': 'Version',
  'changelog.mainTitle': 'Title',
  'changelog.details': 'Details',
  'changelog.publish': 'Publish',
  'changelog.updated': 'Patch updated',
  'changelog.saved': 'Patch published',
  'changelog.confirmDelete': 'Delete this patch note?',
  'changelog.deleted': 'Patch deleted',
  'errors.changelogRequired': 'Version and title are required',

  ...financeProjectMessagesEn,
  ...miscUiMessagesEn,
};

export const featureMessages = {
  th: featureMessagesTh,
  en: featureMessagesEn,
};
